import { createActions } from '../../../context';
import * as actions from './tradeRule-list.actions';

export const tradeRuleList = store => ({
    pagination: {
        currentPage: 1,
        pageSize: 10,
        pagesCount: 1,
        itemsCount: 0
    },
    filters: {
        tradeRuleName: '',
        tradeStatus: true
    },
    providers: [],
    items: [],
    selectedTradeRules: [],
    allSelected: false,
    isLoading:true,
    actions: createActions(actions)(store)
});